import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    widgetContainer: {
      position: 'relative',

      '& > *:not($widget)': {
        zIndex: 2,
      },
    },
    movableWidgetContainer: {
      cursor: 'move',
    },
    widget: {
      width: '100%',
      height: '100%',
    },
    editableWidget: {
      pointerEvents: 'none',
      userSelect: 'none',

      '&::after': {
        content: '""',
        position: 'absolute',
        zIndex: 1,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
      },

      // Use static class for making some room for menu button
      '& .card-header': {
        marginRight: 30 + theme.spacing(),
      },
    },
    emptyWorkspace: {
      marginTop: '20vh',
      textAlign: 'center',
    },
    root: {
      '& .react-grid-item > .react-resizable-handle::after': {
        zIndex: 2,
      },
    },
  };
};
